import React, { createContext, useContext, useEffect, useRef, useSyncExternalStore } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { AUTH_EXPIRED_EVENT } from "../api/client";
import { authService } from "../api/services/auth";
import { clearSession, getSession, saveSession, subscribeSession } from "../auth/session";

const AuthContext = createContext();
const feedback = { position: "bottom-left", rtl: true };

export const AuthProvider = ({ children }) => {
  const session = useSyncExternalStore(subscribeSession, getSession, () => null);
  const pendingLogout = useRef(null);

  useEffect(() => {
    ["token", "memo_cache", "userId"].forEach((key) => Cookies.remove(key, { path: "/" }));
    const expire = () => {
      clearSession();
      toast.error("نشست شما پایان یافته است. لطفاً دوباره وارد شوید.", {
        ...feedback, toastId: "session-expired",
      });
    };
    window.addEventListener(AUTH_EXPIRED_EVENT, expire);
    return () => window.removeEventListener(AUTH_EXPIRED_EVENT, expire);
  }, []);

  const logout = async (all = false) => {
    if (pendingLogout.current) return;
    const token = getSession()?.token;
    const controller = new AbortController();
    pendingLogout.current = controller;
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      await (all ? authService.logoutAll : authService.logout)({ signal: controller.signal });
    } catch (error) {
      if (error.status !== 401) {
        toast.warning("خروج از مرورگر انجام شد؛ لغو نشست در سرور تأیید نشد.", feedback);
      }
    } finally {
      clearTimeout(timeout);
      if (getSession()?.token === token && !clearSession()) {
        toast.error("پاک‌کردن نشست ذخیره‌شده ممکن نشد. داده‌های این سایت را در مرورگر پاک کنید.", feedback);
      }
      pendingLogout.current = null;
    }
  };

  return <AuthContext.Provider value={{
    session, user: session?.user, isLogin: Boolean(session),
    authenticate: saveSession, clearAuthentication: clearSession, logout,
  }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
